class EventSlider extends window.BAO.CustomElement() {
  connectedCallback () {
    this.loading = true

    this.fetchEvents()
  }

  fetchEvents () {
    if (!window.theme?.appUrl) {
      this.loading = false
      return
    }

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
    }

    fetch(`${window.theme.appUrl}/api/events`, requestOptions)
      .then(response => response.json())
      .then(result => {
        // eslint-disable-next-line no-console
        let html = ''
        const events = result?.data?.events
        if (!Array.isArray(events) || events.length === 0) {
          this.remove()
          this.loading = false
          return
        }

        const seriesShown = []

        for (let index = 0; index < events.length; index++) {
          const element = events[index]

          if (!element || !element.start?.local) {
            continue
          }

          if (element.series_id && seriesShown.includes(element.series_id)) {
            continue
          }

          if (element.series_id) {
            seriesShown.push(element.series_id)
          }

          const dateStart = new Date(element.start.local)
          const dateMonth = dateStart.toLocaleString('default', {
            month: 'short',
          })
          const dateDay = dateStart.getDate()
          const venue = element.venue?.name ?? ''
          const title = element.name?.text ?? ''
          const content = element.description?.text ?? ''
          const link = element.url
          const locked = element.locked
          const listed = element.listed
          const free = element.is_free

          if (locked || !listed) {
            continue
          }

          if (this.dataset.country) {
            const countries = this.dataset.country.split(',')
            if (!countries.includes(element.venue?.address?.country)) {
              continue
            }
          }

          html += this.itemHTML(
            dateMonth,
            dateDay,
            venue,
            title,
            content,
            link,
            free,
          )
        }

        if (html === '') {
          this.remove()
          this.loading = false
          return
        }

        if (this.els?.slider?.element) {
          this.els.slider.element.innerHTML = html
        }

        this.loading = false
      })
      .catch(error => {
        console.error(error)
        this.loading = false
      })
  }

  itemHTML (dateMonth, dateDay, venue, title, content, link, free) {
    return `<div class="sec-EventSlider_Item">
      <div class="sec-EventSlider_ItemHeader">
        <div class="sec-EventSlider_ItemDate">
          <span class="sec-EventSlider_ItemDateMonth fz-13_162">${dateMonth}</span>
          <span class="sec-EventSlider_ItemDateDate fz-36_122">${dateDay}</span>
        </div>

        <div class="sec-EventSlider_ItemHeaderContent">
          <p class="sec-EventSlider_ItemTime fz-13_162">${venue}</p>
          <p class="sec-EventSlider_ItemTitle fz-14_171">${title}</p>
        </div>
      </div>

      <div class="sec-EventSlider_ItemMain">
        <div class="sec-EventSlider_ItemContent rte-RichText fz-11_155">
          <p>${content}</p>
        </div>

        <a href="${link}" target="_blank" class="sec-EventSlider_ItemButton btn-Button btn-Button-underline">${
      free
        ? window.theme?.strings?.eventbrite?.free ?? ''
        : window.theme?.strings?.eventbrite?.tickets ?? ''
    }</a>
      </div>
    </div>`
  }

  get loading () {
    return this._loading
  }

  set loading (loading) {
    this._loading = loading

    this.classList.toggle(this.loadingClass, loading)
  }

  get loadingClass () {
    return this.getAttribute('loading-class')
  }
}

if (!customElements.get('event-slider')) {
  customElements.define('event-slider', EventSlider)
}
